import { render, staticRenderFns } from "./Fasit.vue?vue&type=template&id=65bb9323&scoped=true&"
import script from "./Fasit.vue?vue&type=script&lang=js&"
export * from "./Fasit.vue?vue&type=script&lang=js&"
import style0 from "./Fasit.vue?vue&type=style&index=0&id=65bb9323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb9323",
  null
  
)

export default component.exports